import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Root from 'Root';
import App from 'App';
import reportWebVitals from './reportWebVitals';

import 'react-quill/dist/quill.snow.css';
import './scss/scaffolding.scss';
import './scss/utils.scss';
import { ErrorBoundary } from 'components/hocs';
import isMobileAppRuntime from './utils/isMobileAppRuntime';
import { initializeMobileOffline } from './mobile-modules/offline';

// Native iOS/Android must opt into the full viewport before the first React paint.
// Placement/Assessment menus use env(safe-area-inset-*) immediately, before an
// activity TemplateWrapper has a chance to mount.
if (isMobileAppRuntime()) {
  const viewport = document.querySelector('meta[name="viewport"]') || document.createElement('meta');
  viewport.setAttribute('name', 'viewport');
  viewport.setAttribute(
    'content',
    'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
  );

  if (!viewport.parentNode) document.head.appendChild(viewport);
}

const renderApp = () =>
  ReactDOM.render(
    <Root>
      <ErrorBoundary>
        <Router>
          <App />
        </Router>
      </ErrorBoundary>
    </Root>,
    document.getElementById('root')
  );

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', renderApp);
}

if (isMobileAppRuntime()) {
  initializeMobileOffline()
    .catch((error) => console.warn('[mobile-offline] initialization failed', error))
    .finally(renderApp);
} else {
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
